<div class="row">
  <div class="col-md-6 col-12 mt-md-0 mt-2">
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0">Web request form</h5>
      </div>
      <div class="card-body bg-light">

        <div class="row">
          <div class="col-12">
            <b class="mt-1">Fields</b>
            <span class="text-muted d-block fs-12">Manage fields to show on web form</span>
          </div>
        </div>
        <hr class="border-dashed border-bottom-0 mt-1 mb-2" />

        <div class="row">
          <div class="col-lg-9 mt-2">
            <div class="custom-control custom-checkbox cursor-pointer">
              <input class="custom-control-input cursor-pointer" id="emailOpe" [(ngModel)]="webFormData.emailOpe" type="checkbox" (change)="changeWebFormOpe(webFormData.emailOpe,'emailOpe')">
              <label class="custom-control-label cursor-pointer position-relative top--2px" for="emailOpe">Email</label>
            </div>
          </div>
          <div class="col-lg-3 text-right mt-2">
            <div class="d-flex justify-content-end">
              <i class="fs-12 mr-2" *ngIf="webFormData.emailReqOpe">Required</i> <i class="fs-12 mr-2" *ngIf="!webFormData.emailReqOpe && webFormData.emailOpe">Not required</i>
              <div class="custom-control custom-switch">
                <input class="custom-control-input" type="checkbox" id="emailReqOpe" [(ngModel)]="webFormData.emailReqOpe" [disabled]="!webFormData.emailOpe" />
                <label class="custom-control-label cursor-pointer" for="emailReqOpe"></label>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-9 mt-2">
            <div class="custom-control custom-checkbox cursor-pointer">
              <input class="custom-control-input cursor-pointer" id="phoneOpe" [(ngModel)]="webFormData.phoneOpe" type="checkbox" (change)="changeWebFormOpe(webFormData.phoneOpe,'phoneOpe')">
              <label class="custom-control-label cursor-pointer position-relative top--2px" for="phoneOpe">Phone</label>
            </div>
          </div>
          <div class="col-lg-3 text-right mt-2">
            <div class="d-flex justify-content-end">
              <i class="fs-12 mr-2" *ngIf="webFormData.phoneReqOpe">Required</i> <i class="fs-12 mr-2" *ngIf="!webFormData.phoneReqOpe && webFormData.phoneOpe">Not required</i>
              <div class="custom-control custom-switch">
                <input class="custom-control-input" type="checkbox" id="phoneReqOpe" [(ngModel)]="webFormData.phoneReqOpe" [disabled]="!webFormData.phoneOpe" />
                <label class="custom-control-label cursor-pointer" for="phoneReqOpe"></label>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-9 mt-2">
            <div class="custom-control custom-checkbox cursor-pointer">
              <input class="custom-control-input cursor-pointer" id="streetOpe" [(ngModel)]="webFormData.streetOpe" type="checkbox" (change)="changeWebFormOpe(webFormData.streetOpe,'streetOpe')">
              <label class="custom-control-label cursor-pointer position-relative top--2px" for="streetOpe">Street</label>
            </div>
          </div>
          <div class="col-lg-3 text-right mt-2">
            <div class="d-flex justify-content-end">
              <i class="fs-12 mr-2" *ngIf="webFormData.streetReqOpe">Required</i> <i class="fs-12 mr-2" *ngIf="!webFormData.streetReqOpe && webFormData.streetOpe">Not required</i>
              <div class="custom-control custom-switch">
                <input class="custom-control-input" type="checkbox" id="streetReqOpe" [(ngModel)]="webFormData.streetReqOpe" [disabled]="!webFormData.streetOpe" />
                <label class="custom-control-label cursor-pointer" for="streetReqOpe"></label>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-9 mt-2">
            <div class="custom-control custom-checkbox cursor-pointer">
              <input class="custom-control-input cursor-pointer" id="cityOpe" [(ngModel)]="webFormData.cityOpe" type="checkbox" (change)="changeWebFormOpe(webFormData.cityOpe,'cityOpe')">
              <label class="custom-control-label cursor-pointer position-relative top--2px" for="cityOpe">City</label>
            </div>
          </div>
          <div class="col-lg-3 text-right mt-2">
            <div class="d-flex justify-content-end">
              <i class="fs-12 mr-2" *ngIf="webFormData.cityReqOpe">Required</i> <i class="fs-12 mr-2" *ngIf="!webFormData.cityReqOpe && webFormData.cityOpe">Not required</i>
              <div class="custom-control custom-switch">
                <input class="custom-control-input" type="checkbox" id="cityReqOpe" [(ngModel)]="webFormData.cityReqOpe" [disabled]="!webFormData.cityOpe" />
                <label class="custom-control-label cursor-pointer" for="cityReqOpe"></label>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-9 mt-2">
            <div class="custom-control custom-checkbox cursor-pointer">
              <input class="custom-control-input cursor-pointer" id="stateOpe" [(ngModel)]="webFormData.stateOpe" type="checkbox" (change)="changeWebFormOpe(webFormData.stateOpe,'stateOpe')">
              <label class="custom-control-label cursor-pointer position-relative top--2px" for="stateOpe">State</label>
            </div>
          </div>
          <div class="col-lg-3 text-right mt-2">
            <div class="d-flex justify-content-end">
              <i class=" fs-12 mr-2" *ngIf="webFormData.stateReqOpe">Required</i> <i class=" fs-12 mr-2" *ngIf="!webFormData.stateReqOpe && webFormData.stateOpe">Not required</i>
              <div class="custom-control custom-switch">
                <input class="custom-control-input" type="checkbox" id="stateReqOpe" [(ngModel)]="webFormData.stateReqOpe" [disabled]="!webFormData.stateOpe" />
                <label class="custom-control-label cursor-pointer" for="stateReqOpe"></label>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-9 mt-2">
            <div class="custom-control custom-checkbox cursor-pointer">
              <input class="custom-control-input cursor-pointer" id="zipOpe" [(ngModel)]="webFormData.zipOpe" type="checkbox" (change)="changeWebFormOpe(webFormData.zipOpe,'zipOpe')">
              <label class="custom-control-label cursor-pointer position-relative top--2px" for="zipOpe">ZIP</label>
            </div>
          </div>
          <div class="col-lg-3 text-right mt-2">
            <div class="d-flex justify-content-end">
              <i class=" fs-12 mr-2" *ngIf="webFormData.zipReqOpe">Required</i> <i class=" fs-12 mr-2" *ngIf="!webFormData.zipReqOpe && webFormData.zipOpe">Not required</i>
              <div class="custom-control custom-switch">
                <input class="custom-control-input" type="checkbox" id="zipReqOpe" [(ngModel)]="webFormData.zipReqOpe" [disabled]="!webFormData.zipOpe" />
                <label class="custom-control-label cursor-pointer" for="zipReqOpe"></label>
              </div>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="col-lg-9 mt-2">
            <div class="custom-control custom-checkbox cursor-pointer">
              <input class="custom-control-input cursor-pointer" id="typeOpe" [(ngModel)]="webFormData.typeOpe" type="checkbox" (change)="changeWebFormOpe(webFormData.typeOpe,'typeOpe')">
              <label class="custom-control-label cursor-pointer position-relative top--2px" for="typeOpe">Type</label>
            </div>
          </div>
          <div class="col-lg-3 text-right mt-2">
            <div class="d-flex justify-content-end">
              <i class=" fs-12 mr-2" *ngIf="webFormData.typeReqOpe">Required</i> <i class=" fs-12 mr-2" *ngIf="!webFormData.typeReqOpe && webFormData.typeOpe">Not required</i>
              <div class="custom-control custom-switch">
                <input class="custom-control-input" type="checkbox" id="typeReqOpe" [(ngModel)]="webFormData.typeReqOpe" [disabled]="!webFormData.typeOpe" />
                <label class="custom-control-label cursor-pointer" for="typeReqOpe"></label>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-9 mt-2">
            <div class="custom-control custom-checkbox cursor-pointer">
              <input class="custom-control-input cursor-pointer" id="descOpe" [(ngModel)]="webFormData.descOpe" type="checkbox" (change)="changeWebFormOpe(webFormData.descOpe,'descOpe')">
              <label class="custom-control-label cursor-pointer position-relative top--2px" for="descOpe">Description</label>
            </div>
          </div>
          <div class="col-lg-3 text-right mt-2">
            <div class="d-flex justify-content-end">
              <i class=" fs-12 mr-2" *ngIf="webFormData.descReqOpe">Required</i> <i class=" fs-12 mr-2" *ngIf="!webFormData.descReqOpe && webFormData.descOpe">Not required</i>
              <div class="custom-control custom-switch">
                <input class="custom-control-input" type="checkbox" id="descReqOpe" [(ngModel)]="webFormData.descReqOpe" [disabled]="!webFormData.descOpe" />
                <label class="custom-control-label cursor-pointer" for="descReqOpe"></label>
              </div>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="col-lg-9 mt-2">
            <div class="custom-control custom-checkbox cursor-pointer">
              <input class="custom-control-input cursor-pointer" id="fileOpe" [(ngModel)]="webFormData.fileOpe" type="checkbox" (change)="changeWebFormOpe(webFormData.fileOpe,'fileOpe')">
              <label class="custom-control-label cursor-pointer position-relative top--2px" for="fileOpe">Attachment</label>
            </div>
          </div>
          <div class="col-lg-3 text-right mt-2">
            <div class="d-flex justify-content-end">
              <i class=" fs-12 mr-2" *ngIf="webFormData.fileReqOpe">Required</i> <i class=" fs-12 mr-2" *ngIf="!webFormData.fileReqOpe && webFormData.fileOpe">Not required</i>
              <div class="custom-control custom-switch">
                <input class="custom-control-input" type="checkbox" id="fileReqOpe" [(ngModel)]="webFormData.fileReqOpe" [disabled]="!webFormData.fileOpe" />
                <label class="custom-control-label cursor-pointer" for="fileReqOpe"></label>
              </div>
            </div>
          </div>
        </div>





        <div class="row">
          <div class="col-12 mt-3">
            <b class="mt-1">Notifications</b>
            <span class="text-muted d-block fs-12">Choose user to send notification for requests from web</span>
          </div>
        </div>
        <hr class="border-dashed border-bottom-0 mt-1 mb-2" />

        <div class="row">
          <div class="col-12 mb-2">
            <div class="form-group mb-1 mb-07-rem">
              <label>Assignees</label>
            </div>
            <ul class="nav avatar-group mb-0">
              <li class="nav-item dropdown" *ngFor="let asg of webFormData.assigner;let index = index">
                <div class="nav-link p-0 dropdown-toggle dropdown-caret-none">
                  <div class="avatar avatar-xl remove-asg " [ngClass]="{'ml-minus04rem':index>0}">
                    <img class="rounded-circle" *ngIf="asg.img?.length>0" style="border:1px solid #fff" src="{{asg.img}}" alt="" data-toggle="tooltip" data-placement="top" title="{{asg.name}}" />
                    <span class="circle-user-icon color-white avatar-button fs-14" *ngIf="asg.img?.length==0" data-toggle="tooltip" data-placement="top" title="{{asg.name}}"><i class="fas fa-user"></i></span>
                    <div class="overlay-remove">
                      <a (click)="assignerChange(index,asg,'remove')" class="icon-remove" data-toggle="tooltip" data-placement="top" title="Remove {{asg.name}}">
                        <i class="fas fa-times"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link p-0 dropdown-toggle dropdown-caret-none" id="dropDownAssigner"
                   data-toggle="dropdown">
                  <span class="circle-dashed cursor-pointer" style="width: 32px; height: 32px;"><span class="fas fa-plus"></span></span>
                </a>
                <div class="dropdown-menu dropdown-md">
                  <h6 class="dropdown-header py-0 px-3 mb-0">Select Member</h6>
                  <div class="dropdown-divider"></div>
                  <div class="px-3 mb-2">
                    <input class="form-control form-control-sm" type="search"
                           placeholder="Search team member" [(ngModel)]="searchAssigner" />
                  </div>
                  <ul class="list-unstyled  max-height300px overflow-y-auto">
                    <li *ngFor="let m of webFormData.assignerList |filter :searchAssigner ;let index=index" (click)="assignerChange(index,m,'add')" [ngClass]="{'disabledLi': m.disabledAssigner==1}">
                      <a class="media align-items-center text-decoration-none hover-200 py-1 px-3 cursor-pointer">
                        <div class="avatar avatar-xl ml-minus05rem">
                          <img class="rounded-circle" *ngIf="m.img?.length>0" src="{{m.img}}" alt="" />
                          <span class="circle-user-icon color-white avatar-button fs-14" *ngIf="m.img?.length==0"><i class="fas fa-user"></i></span>
                        </div>
                        <div class="media-body ml-2">
                          <h6 class="mb-0">{{m.name}}</h6>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>



        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="hashCode">Web form link</label>
              <div class="input-group input-group-sm">
                <input type="text" name="webFormUrl" autocomplete="off" #webFormUrl class="form-control form-control-sm" id="webFormUrl" tabindex="12" [(ngModel)]="webFormData.webFormUrl" disabled />
                <div class="input-group-append"><button class="btn btn-sm" style="border: 1px solid #eee;" (click)="webFormUrl.select();copyStringToClipboard(webFormData.webFormUrl)"><i class="fas fa-copy"></i></button></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="hashCode">Return URL</label>
                <input type="text" name="webFormReturnUrl" autocomplete="off" #webFormReturnUrl class="form-control form-control-sm" id="webFormReturnUrl" tabindex="13" [(ngModel)]="webFormData.webFormReturnUrl" />
              </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="hashCode">Iframe code</label>
              <div class="input-group input-group-sm">
                <input type="text" name="webFormIframe" autocomplete="off" #webFormIframe class="form-control form-control-sm" id="webFormIframe" tabindex="14" [(ngModel)]="webFormData.webFormIframe" disabled />
                <div class="input-group-append"><button class="btn btn-sm" style="border: 1px solid #eee;" (click)="webFormIframe.select();copyStringToClipboard(webFormData.webFormIframe)"><i class="fas fa-copy"></i></button></div>
              </div>
            </div>
          </div>
        </div>





        <!--<div class="col-md-6 col-12">
    <div class="form-group mb-1">
      <label class="fs-12 mb-0 text400" for="name">Name</label>
      <input type="text" id="name" title="Company name" class="form-control form-control-sm" [(ngModel)]="companyInfo.name" tabindex="1" autocomplete="off" autofocus required />
    </div>
  </div>-->




        <div class="row">
          <div class="col-12 mt-3">
            <button class="btn btn-primary btn-sm float-right" (click)="saveWebFormInfo()">
              <div class="g_spinner" *ngIf="spinner"></div>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
